import axios, { AxiosError } from 'axios';
import { useQuery, UseQueryOptions, QueryKey } from 'react-query';

import type { DefaultGetAllResponse } from '~/App/Api/rest';
import { ProfileEvent } from '~/types/models';

const queryKeys = {
  all: ['profile-events'] as const,
  details: () => [...queryKeys.all, 'details'] as const,
  detail: (profileId?: string) => [...queryKeys.details(), profileId] as const,
};

export { queryKeys as profileEventsQueryKeys };

export interface ProfileEventFiltersParams {
  profileId?: string;
}

export async function fetchProfileEvents(profileId: string) {
  const res = await axios.get<DefaultGetAllResponse<ProfileEvent>>(
    '/api/v2/events',
    {
      params: {
        profile_id: profileId,
      },
    }
  );

  return res.data;
}

export function useProfileEvents(
  profileId: string,
  options?: UseQueryOptions<DefaultGetAllResponse<ProfileEvent>, AxiosError>
) {
  return useQuery<DefaultGetAllResponse<ProfileEvent>, AxiosError>(
    queryKeys.detail(profileId) as QueryKey,
    () => fetchProfileEvents(profileId),
    options
  );
}
